export default __webpack_public_path__ + "static/media/pagbank.625a0c21.svg";